import {TFunction} from "i18next";
import {Alert, Snackbar, Typography} from "@mui/material";
import React from "react";

interface MaileonAlertProps {
    snackbar: {
        open: boolean
        message: string
        severity: "success" | "error" | "info" | "warning"
    }
    setSnackbar: React.Dispatch<React.SetStateAction<{
        open: boolean
        message: string
        severity: "success" | "error" | "info" | "warning"
    }>>
    t: TFunction,
    autoHideDuration?: number
    anchorOriginVertical?: "top" | "bottom"
    anchorOriginHorizontal?: "left" | "center" | "right"
    alertVariant?: "filled" | "outlined" | "standard"
    typographyVariant?: "h6" | "body1" | "body2" | "subtitle1" | "subtitle2"
}

export const MaileonSnackbar: React.FC<MaileonAlertProps> = ({
    snackbar,
    setSnackbar,
    t,
    autoHideDuration = 6000,
    anchorOriginVertical = "bottom",
    anchorOriginHorizontal = "right",
    alertVariant = "filled",
    typographyVariant = "h6"
}) => {
    const handleClose = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    }

    return (
        <Snackbar
            open={snackbar.open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: anchorOriginVertical, horizontal: anchorOriginHorizontal }}
        >
            <Alert
                onClose={handleClose}
                severity={snackbar.severity}
                variant={alertVariant}
            >
                <Typography variant={typographyVariant}>
                    {t(snackbar.message)}
                </Typography>
            </Alert>
        </Snackbar>
    )
}
